module.exports = __webpack_public_path__ + "static/media/expat_5.46d75bca.webp";